module.exports = __webpack_public_path__ + "img/video_call_established.b7c64419.png";